import Stage from "../../modules/stage/Stage";
import Section from "../../modules/section/Section";
import AtmLink from "../../atoms/atmLink/AtmLink";
import { ENUMS } from "../../../enums/enums";
import Picture from "../../atoms/picture/Picture";
import bg from "../../../assets/images/3.jpg";
import pen from "../../../assets/images/pen.png";
import pen_mob from "../../../assets/images/pen_mob.png";
import lex from "../../../assets/images/lex.png";
import ServicesIconList from "../../modules/servicesIconList/ServicesIconList";
import CardList from "../../modules/cardList/CardList";
import { useTranslation } from "react-i18next";
import cardlist1 from "../../../assets/images/cardlist1.png";
import cardlist1_mob from "../../../assets/images/cardlist1_mob.png";
import cardlist2 from "../../../assets/images/cardlist2.png";
import cardlist2_mob from "../../../assets/images/cardlist2_mob.png";
import cardlist3 from "../../../assets/images/cardlist3.png";
import cardlist4 from "../../../assets/images/cardlist4.png";

const Home = () => {
  const { t } = useTranslation();
  const projects = [
    {
      title: t("energyInfrastructureTitle"),
      superTitle: t("energyInfrastructure"),
      link: "projects/energy-and-infrastructure",
      src: cardlist1,
      srcMob: cardlist1_mob,
    },
    {
      title: t("miningTitle"),
      superTitle: t("mining"),
      link: "projects/mining",
      src: cardlist3,
      srcMob: cardlist3,
    },
    {
      title: t("realEstateTitle"),
      superTitle: t("realEstate"),
      link: "projects/real-estate",
      src: cardlist2,
      srcMob: cardlist2_mob,
    },
    {
      title: t("MATitle"),
      superTitle: t("MA"),
      link: "projects/m-and-a",
      src: cardlist4,
      srcMob: cardlist4,
    },
  ];

  return (
    <>
      <Section marginBottom>
        <Stage />
      </Section>

      <Section twoColumn container>
        <h2>{t("aboutUs")}</h2>
        <div>
          <p>{t("homeAboutUsDescription")}</p>
          <AtmLink className={"mt-md"} to={ENUMS.ROUTE_ABOUT_US}>
            {t("viewMore")}
          </AtmLink>
        </div>
      </Section>

      <Section marginBottom>
        <Picture
          className={"atm-picture--group bw-image"}
          srcDesktop={bg}
          srcMobile={bg}
          alt={"Man and girl in busy city street"}
        />
      </Section>

      <Section twoColumn container largeGap>
        <div>
          <h2>{t("services")}</h2>
          <p className={"mt-sm"}>{t("homeServicesDescription")}</p>
          <AtmLink className={"mt-sm"} to={ENUMS.ROUTE_SERVICES}>
            {t("viewMore")}
          </AtmLink>
        </div>
        <ServicesIconList />
      </Section>

      <Section marginBottom>
        <div className={"container header-container"}>
          <h2>{t("projects")}</h2>
          <AtmLink className={"mt-sm"} to={ENUMS.ROUTE_PROJECTS}>
            {t("viewMore")}
          </AtmLink>
        </div>
        <CardList cards={projects} />
      </Section>

      <Section marginBottom>
        <Picture
          srcDesktop={pen}
          srcMobile={pen_mob}
          alt={"A pen on a table"}
        />
      </Section>

      <Section twoColumn container>
        <h2>{t("lex")}</h2>
        <div>
          <a
            href="https://www.lexadria.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Picture
              srcDesktop={lex}
              srcMobile={lex}
              alt={"Lex logo"}
              className={"atm-picture--lex"}
            />
          </a>
          <p className={"mt-sm"}>{t("homeLexDescription")}</p>
          <AtmLink className={"mt-md"} to={"https://www.lexadria.com/"}>
            {t("viewMore")}
          </AtmLink>
        </div>
      </Section>
    </>
  );
};

export default Home;
